import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="py-6 sm:py-12 px-4 bg-brand-olive-dark text-white" data-id="element-53">
      <div className="max-w-xl mx-auto text-center" data-id="element-54">
        <div className="mb-4 sm:mb-7" data-id="element-55">
          <h2 className="text-xl sm:text-4xl font-serif font-bold mb-2 sm:mb-4" data-id="element-56">
            Smetti di rimandare. Inizia oggi il tuo Reset.
          </h2>
          <p className="text-sm sm:text-lg text-gray-200 font-medium" data-id="element-57">
            Ritrova la leggerezza che meriti con il sistema più completo in
            Italia.
          </p>
        </div>

        <div className="space-y-4" data-id="element-58">
          <CTAButton href="https://italia.kitonline.shop/cart/44759699554439:1" variant="premium" className="w-full sm:w-auto min-w-0 sm:min-w-[300px]" data-id="element-59">
            INIZIA IL TUO RESET ORA
          </CTAButton>

          <p className="text-xs sm:text-sm text-gray-400 mt-4" data-id="element-60">
            oppure{' '}
            <a href="https://italia.kitonline.shop/cart/44759694901383:1" className="text-white underline hover:text-brand-gold" data-id="element-61">
              PACK ESSENTIAL — €19,90
            </a>
          </p>
        </div>
      </div>
    </section>;
}